<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <div v-if="contractId && contractData">
      <div class="row">
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Nº Contrato</div>
          <div>{{ contractData.contractId || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Producto</div>
          <div>{{ contractData.product.name || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">IMEI</div>
          <div>{{ contractData.product.imei || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">PH</div>
          <div>{{ contractData.logisticOrderId || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Fecha de Inicio</div>
          <div>{{ $dateBackToFront(contractData.date, true) }}
          </div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Fecha de Finalización</div>
          <div>{{ $dateBackToFront(contractData.endDate) }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Cuota mensual</div>
          <div>{{ contractData.payment.totalFee || '-' }}€</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Cuota total</div>
          <div>{{ contractData.product.retailPrice || '-' }}€</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Estado</div>
          <div>{{ contractData.status || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Tienda</div>
          <div>{{ contractData.storeNumber || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Número de póliza</div>
          <div>{{ contractData.policy.policyNumber || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Tracking</div>
          <div>{{ contractData.tracking || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Distribuidor</div>
          <div>{{ contractData.merchant || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Url consulta</div>
          <div><a href="https://s.correosexpress.com/" target="_blank">https://s.correosexpress.com/</a></div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import axios from 'axios';
import Modal from '../../../Shared/Modal.vue';

export default {
  name: 'ContractDetail',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId'
  ],
  data() {
    return {
      classes: this.class,
      contractData: '',
    };
  },
  updated() {
    this.loadContractData();
  },
  components: {
    Modal,
  },
  methods: {
    loadContractData() {
      axios.get(`/contract/${this.contractId}`)
        .then((response) => {
          this.contractData = response.data;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
